import React, { useState, useEffect } from "react";
import "./style.scss";
import { EditOutlined, DeleteOutlined, LeftOutlined } from "@ant-design/icons";
import { blue, red } from "@ant-design/colors";
import { Layout, Space, Button, Table, Popconfirm, Card } from "antd";
import R2Footer from "../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddDiscountCodes from "./AddDiscountCodes";
import DiscountService from "../../services/DiscountService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

const { Content } = Layout;

const DiscountCodes = (props) => {
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [updateDiscount, setUpdateDiscount] = useState();
  const [discountSection, setDiscountSection] = useState();
  const [discounts, setDiscounts] = useState([]);
  const history = useHistory();

  const adminRestaurant = useSelector((state) => state.admin);
  const columns = [
    {
      title: "Action",
      render: (_, record) => {
        return (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
            }}
          >
            {discounts.length > 0 && (
              <>
                <EditOutlined
                  style={{ color: blue[5] }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setUpdateDiscount(record);
                    setEdit(true);
                    setAddModal(true);
                  }}
                />{" "}
                &nbsp;&nbsp;
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={(e) => {
                    e.stopPropagation();
                    deleteCode(record.id);
                  }}
                >
                  <DeleteOutlined style={{ color: red[5] }} />
                </Popconfirm>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Valid from",
      dataIndex: "valid_from",
      key: "valid_from",
    },
    {
      title: "Valid till",
      dataIndex: "valid_till",
      key: "valid_till",
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (text) => (
        <b style={{ color: blue[5], cursor: "pointer" }}>
          {text ? "Active" : "Not Active"}
        </b>
      ),
    },
  ];

  const deleteCode = async (id) => {
    await DiscountService.deleteDiscountCode(id);
    getDiscountCodes();
  };

  useEffect(() => {
    getDiscountCodes();
    getDiscount();
  }, []);

  const getDiscount = async () => {
    const id = props.match.params.discountId;
    const data = await DiscountService.getDiscountsCode(id);
    setDiscountSection(data);
  };

  const closeModal = (status) => {
    setAddModal(status);
    getDiscountCodes();
  };

  const getDiscountCodes = async () => {
    const data = await DiscountService.getDiscountDetails(adminRestaurant);
    if (data.discount_codes && data.discount_codes.length > 0)
      setDiscounts(
        data.discount_codes.filter(
          (item) => item.discount_id == props.match.params.discountId
        )
      );
  };

  return (
    <Layout style={{ padding: "0 24px 24px" }}>
      <Content
        className="site-layout-background"
        style={{
          padding: 24,
          margin: "16px 0px",
          minHeight: 280,
        }}
      >
        <div style={{ background: "white" }}>
          <span className="back-btn" onClick={() => history.push(`/business/discounts`)}>
            <LeftOutlined /> Back to Discounts
          </span>
        </div>
        <Space direction="vertical" style={{ width: "100%" }}>
          <h3>Discount Codes</h3>
          <div className="menu-bar">
            <Button
              className="success"
              onClick={() => {
                setEdit(false);
                setAddModal(true);
              }}
            >
              Add Discount Code
            </Button>
          </div>
          {discountSection && (
            <Card title="Discount">
              <div className="catering-value">
                Discount Name : {discountSection.name}
              </div>
              <div className="catering-value">
                Discount Type : {discountSection.type}
              </div>
              <div className="catering-value">
                Count to Check : {discountSection.count_to_check}
              </div>
              <div className="catering-value">
                Count to Discount : {discountSection.count_to_discount}
              </div>
              <div className="catering-value">
                Value : {discountSection.value}
              </div>
            </Card>
          )}
          <Table
            columns={columns}
            dataSource={discounts}
            pagination={false}
            onRow={(discount) => {
              return {
                onClick: (event) => {
                  history.push(`/discount-codes/${discount.id}`);
                },
              };
            }}
          />
        </Space>
      </Content>
      <R2Footer />
      {addModal && (
        <AddDiscountCodes
          modalOpen={true}
          isEdit={isEdit}
          closeModal={closeModal}
          updateDiscount={updateDiscount}
          discountId={props.match.params.discountId}
        />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(DiscountCodes));
